import { useEffect, useRef, useState } from "react";

interface UseScrollFadeOptions {
  threshold?: number;
  rootMargin?: string;
}

export function useScrollFade<T extends HTMLElement>({
  threshold = 0.1,
  rootMargin = "0px 0px -50px 0px",
}: UseScrollFadeOptions = {}) {
  const ref = useRef<T>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(element);
        }
      },
      { threshold, rootMargin }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [threshold, rootMargin]);

  return { ref, isVisible };
}
